<template>
  <v-container fluid>
    <v-layout row>
      <v-flex>
        <v-card>
          <v-card-title primary-title class="primary white--text headline">
            Releases
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
            <v-timeline>
              <v-timeline-item v-for="(item,i) in items" :key=i large fill-dot>
                <template v-slot:opposite>
                  <span v-html="item.description"></span>
                </template>
                <v-card class="elevation-2">
                  <v-card-title primary-title class="primary">
                    <div>
                      <h2 class="display-1 white--text">{{ item.version }}</h2>
                      <span class="white--text"> Released at: {{item.appliedDate | formatDate}}</span>
                    </div>
                  </v-card-title>
                  <v-card-text>
                    <ul>
                      <li v-for="(releaseNote,k) in item.releaseNotes" :key=k>
                        {{ releaseNote }}
                      </li>
                    </ul>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      items: [],
      systemVersionListLoading: false
    }
  },
  created () {
    this.systemVersionListLoading = true
    this.fetchSystemConfigurations()
  },
  methods: {
    fetchSystemConfigurations () {
      this.axios.get('/system-version')
        .then(response => {
          response.data.forEach(systemVersion => {
            this.items.push({
              id: systemVersion.id,
              releaseNotes: systemVersion.release_notes,
              description: systemVersion.description,
              version: systemVersion.version,
              appliedDate: new Date(systemVersion.applied_date)
            })
          })
          console.log(this.items)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.systemVersionListLoading = false
        })
    }
  }
}
</script>

<style>

</style>
